import { FC } from 'react';
import { numberFormat, Text } from '@mofid-securities/uikit';
import { AssetAmount } from './components/AssetAmount';
import { useIsMasked } from '@/hooks/isMasked';
import { useFindFundAssetByFundCode } from '../../../../../../hooks/useFindFundAsset';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useGetUserStatus } from '@/userStatus/hooks';

export const AssetsValue: FC = () => {
  const fundCode = useGetFundCodeFromQuery();
  const { isMasked, maskedSymbol } = useIsMasked('sideBarMasked');
  const { isVerified } = useGetUserStatus();

  // * Always mask for unverified user
  const shouldMask = !isVerified || isMasked;

  const { fundAsset } = useFindFundAssetByFundCode(fundCode, true);

  const { count } = fundAsset || {};

  const formattedCount = count !== undefined ? numberFormat(count) : '-';

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex items-center justify-between">
        <Text
          className="text-gray-filled-secondary-enabled"
          size="sm"
          weight="demibold"
        >
          دارایی شما
        </Text>
        <div className="flex items-center gap-x-1">
          <Text
            className="text-gray-filled-secondary-enabled"
            size="sm"
            weight="medium"
          >
            {shouldMask ? maskedSymbol : formattedCount}
          </Text>
          <Text className="text-gray-filled-tertiary-enabled" size="xxs">
            واحد
          </Text>
        </div>
      </div>
      <AssetAmount />
    </div>
  );
};
